import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  disable(event) {
    const submitter = event.detail.formSubmission.submitter
    if (!submitter) return

    // re-disable submit button after Turbo un-disabled it for the long redirect
    submitter.disabled = true
    submitter.innerText = submitter.dataset.turboSubmitsWith
  }
}
